var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"quest-list"},_vm._l((_vm.questProtoIds),function(questProtoId){return _c('li',{key:questProtoId},[_c('span',{staticClass:"custom-code"},[_vm._v(_vm._s(_vm._f("getProtoAlias")(questProtoId)))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }